import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsBaseInputField from "./_imports/forms-base-input-field.vue";

export default {
	name: 'forms-input-field',
	template: getVueTemplate('forms-input-field'),
	mixins: [
		FormsBaseInputField
	]
};